import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { DomSanitizer, SafeResourceUrl  } from '@angular/platform-browser';
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { EjercicioModel, tiposEjercicios, musculosEjercicios, nivelesEjercicios, mecanicasEjercicios, equiposEjercicios } from 'src/app/models/ejercicio.model';
import { DocumentsService } from 'src/app/services/document.service';
import { UploadService } from 'src/app/services/upload.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-ejercicios',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule, 
    ImageCropperModule
  ],
  templateUrl: './ejercicios.component.html',
  styleUrl: './ejercicios.component.css'
})
export class EjerciciosComponent {
  @Input({required: true}) userInfo: any;
  pattern: string = 'ejercicio';
  
  formEjercicio: FormGroup;
  listaEjercicios: EjercicioModel[] = [];
  listaEjerciciosFiltrada: EjercicioModel[] = [];
  submitFormEjercicios: boolean = false;
  editarEjercicio: any = false;

  // Filtros
  tiposEjercicios = tiposEjercicios;
  musculosEjercicios = musculosEjercicios;
  nivelesEjercicios = nivelesEjercicios;
  mecanicasEjercicios = mecanicasEjercicios;
  equiposEjercicios = equiposEjercicios;
  tagTipoSeleccionado: any = "";
  tagNivelSeleccionado: any = "";
  tagMecanicaSeleccionado: any = "";

  // tags en ejercicio
  tiposEjerciciosEj = tiposEjercicios;
  musculosEjerciciosEj = musculosEjercicios;
  nivelesEjerciciosEj = nivelesEjercicios;
  mecanicasEjerciciosEj = mecanicasEjercicios;
  equiposEjerciciosEj = equiposEjercicios;

  filtroTipo = '';
  filtroMusculo = '';
  filtroNivel = '';
  filtroMecanica = '';
  filtroEquipo = '';
  filtroPropietario = 'todos'
  filtroNombreTemp: string = '';

  arrTags: any = [];
  arrTagsSearch: any = [];
  arrTagsFilter: any = [];

  env: any = environment

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private sanitizer: DomSanitizer,
              private uploadService: UploadService,
              private utilsService: UtilsService) {
    this.formEjercicio = this.fb.group
    ({
        nombre1: ['', [Validators.required]],
        nombre2: [''],

        tipo: [''],
        nivel: [''],
        mecanica: [''],
        equipo: [''],
        musculo: [''],
        otros1: [''],
        otros2: [''],
        otros3: [''],

        posicionInicial: [''],
        descripcion: [''],
        notas: [''],
        linkVideo: [''],
        linkAdicional1: [''],
        linkAdicional2: [''],
        linkAdicional3: [''],
        linkAdicional4: [''],
        linkAdicional5: [''],
    })
  }
  ngOnInit(): void {
    this.getEjercicios();
    this.arrTags = []
  }

  @Output() messageEvent = new EventEmitter<string>();
  sendEjercicioSelected(ejercicio) {
    this.messageEvent.emit(ejercicio);
  }
  
  getEjercicios() 
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);

    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )

    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.pattern, query).subscribe({
        next: (data: any) => {
          console.log(data)
          this.listaEjercicios = [];
          this.listaEjercicios = [...data];
          this.listaEjerciciosFiltrada = [...data];
        },
        error: (error: any) => {
          console.error(error);
          this.listaEjercicios = [];
          this.listaEjerciciosFiltrada = [];
        }
      });
    }, 1500);
  }

  /**************************************************/
  /************ AGREGAR/EDITAR EJERCICIO *************/
  modalEjercicio()
  {
    $('#modal-ejercicio').modal({backdrop: 'static', keyboard: false})
    $("#modal-ejercicio").modal('show');
  }
  modalEditarEjercicio(ejercicio)
  {
    this.editarEjercicio = ejercicio;
    this.formEjercicio.patchValue({
      nombre1: ejercicio.nombre1,
      nombre2: ejercicio.nombre2,

      tipo: ejercicio.tipo,
      nivel: ejercicio.nivel,
      mecanica: ejercicio.mecanica,
      equipo: ejercicio.equipo,
      musculo: ejercicio.musculo,

      posicionInicial: ejercicio.posicionInicial,
      descripcion: ejercicio.descripcion,
      notas: ejercicio.notas,
      linkVideo: ejercicio.linkVideo != null && ejercicio.linkVideo != '' ? ejercicio.linkVideo.replace('https://youtu.be/', '') : ''
    })

    if(ejercicio.linkVideo != null && ejercicio.linkVideo != '') this.updateVideoDetails()
    ejercicio.otros.forEach((valor, index) => {
        this.formEjercicio.patchValue({ [`otros${index + 1}`]: valor });
    });
    ejercicio.linksAdicionales.forEach((valor, index) => {
      this.formEjercicio.patchValue({ [`linkAdicional${index + 1}`]: valor });
    });
    if(ejercicio.imagenPosicionInicial) this.previewUrlInicial = ejercicio.imagenPosicionInicial.url;
    if(ejercicio.imagenPosicionFinal) this.previewUrlFinal = ejercicio.imagenPosicionFinal.url;
    let ejercicioTags: any = []
    if(ejercicio.tags){
      ejercicioTags = ejercicio.tags
    }
    this.arrTags = ejercicioTags
    this.formEjercicio.get('tipo').disable();
    this.modalEjercicio();
  }
  createOrUpdateEjercicioFn() {
    this.submitFormEjercicios = true;
    if(this.formEjercicio.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    let linksAdicionalesArray = []
    if(this.formEjercicio.get('linkAdicional1').value) linksAdicionalesArray.push(this.formEjercicio.get('linkAdicional1').value);
    if(this.formEjercicio.get('linkAdicional2').value) linksAdicionalesArray.push(this.formEjercicio.get('linkAdicional2').value);
    if(this.formEjercicio.get('linkAdicional3').value) linksAdicionalesArray.push(this.formEjercicio.get('linkAdicional3').value);
    if(this.formEjercicio.get('linkAdicional4').value) linksAdicionalesArray.push(this.formEjercicio.get('linkAdicional4').value);
    if(this.formEjercicio.get('linkAdicional5').value) linksAdicionalesArray.push(this.formEjercicio.get('linkAdicional5').value);

    let otrosArray = []
    if(this.formEjercicio.get('otros1').value) otrosArray.push(this.formEjercicio.get('otros1').value);
    if(this.formEjercicio.get('otros2').value) otrosArray.push(this.formEjercicio.get('otros2').value);
    if(this.formEjercicio.get('otros3').value) otrosArray.push(this.formEjercicio.get('otros3').value);

    let ejercicioDocModel: EjercicioModel = {
      activo: true,
      nombre1: this.formEjercicio.get('nombre1').value,
      nombre2: this.formEjercicio.get('nombre2').value,
      tipo: this.formEjercicio.get('tipo').value,
      nivel: this.formEjercicio.get('nivel').value,
      mecanica: this.formEjercicio.get('mecanica').value,
      equipo: this.formEjercicio.get('equipo').value,
      musculo: this.formEjercicio.get('musculo').value,
      otros: otrosArray,
      posicionInicial: this.formEjercicio.get('posicionInicial').value,
      descripcion: this.formEjercicio.get('descripcion').value,
      notas: this.formEjercicio.get('notas').value,
      linkVideo: 'https://youtu.be/' + this.formEjercicio.get('linkVideo').value,
      linksAdicionales: linksAdicionalesArray,
      propietario: this.userInfo.documentContainerId,
      empresaId: this.userInfo.empresaId,
      tags: this.arrTags
    };

    if(this.croppedImageInicial!='' && this.rawFileInicial!=null) ejercicioDocModel.imagenPosicionInicial = { nombre: this.rawFileInicial.name, url: this.rawFileInicial.url };
    if(this.croppedImageFinal!='' && this.rawFileFinal!=null) ejercicioDocModel.imagenPosicionFinal =  { nombre:this.rawFileFinal.name, url: this.rawFileFinal.url };

    if(this.croppedImageInicial=='' && this.rawFileInicial==null && this.previewUrlInicial==null) ejercicioDocModel.imagenPosicionInicial = null;
    if(this.croppedImageFinal=='' && this.rawFileFinal==null && this.previewUrlFinal==null) ejercicioDocModel.imagenPosicionFinal = null;
    
    console.log(ejercicioDocModel)
    if(this.editarEjercicio) this.updateEjercicioFn(ejercicioDocModel, this.editarEjercicio.documentId);
    if(!this.editarEjercicio) this.createEjercicioFn(ejercicioDocModel);
  }
  createEjercicioFn(ejercicioDocModel) {
    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.pattern,
      null,
      ejercicioDocModel,
    ).subscribe({
      next: (data) => {
          // debugger
          console.log(data);
          this.submitFormEjercicios = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Ejercicio guardado con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-ejercicio").modal('hide');
          this.getEjercicios();
          this.inicializarFormEjercicio();
        },
      error: (error) => {
        console.error(error);
        //this.loading = false;
      },
    });
  }
  updateEjercicioFn(ejercicioDocModel: EjercicioModel, documentId) {
    let title = ''
    if(ejercicioDocModel.activo) title = "Ejercicio actualizado con éxito";
    if(!ejercicioDocModel.activo) title = "Ejercicio eliminado con éxito";

    this.documentService
      .updateDocumentInContainer(
        environment.businessId,
        this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
        documentId,
        this.pattern,
        null,
        ejercicioDocModel
      )
      .subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormEjercicios = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: title,
            showConfirmButton: false,
            timer: 1500
          });
          if(ejercicioDocModel.activo) $("#modal-ejercicio").modal('hide');
          //this.getEjercicios();
          this.inicializarFormEjercicio();
          if(ejercicioDocModel.activo) this.consultaEjerciciosTags()
          if(!ejercicioDocModel.activo) this.getEjercicios()

        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  deleteEjercicioFn(ejercicioDocModel) {
    Swal.fire({
      title: 'Eliminar ejercicio',
      html: '¿Seguro que desea eliminar el ejercicio: <b>"'+ejercicioDocModel.nombre1+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        ejercicioDocModel.activo = false;
        this.updateEjercicioFn(ejercicioDocModel, ejercicioDocModel.documentId)
      }
    })
  }

  inicializarFormEjercicio()
  {
    this.editarEjercicio = false;
    this.formEjercicio.get('tipo').enable();
    this.deleteImage('inicial');
    this.deleteImage('final');
    this.videoUrl = null;
    this.arrTags = []
    console.log(this.arrTags)
    this.formEjercicio.setValue({
      nombre1: '',
      nombre2: '',
      tipo: '',
      nivel: '',
      mecanica: '',
      equipo: '',
      musculo: '',
      otros1: '',
      otros2: '',
      otros3: '',

      posicionInicial: '',
      descripcion: '',
      notas: '',
      linkVideo: '',
      linkAdicional1: '',
      linkAdicional2: '',
      linkAdicional3: '',
      linkAdicional4: '',
      linkAdicional5: '',
    })
  }

  /******************* IMÁGENES ********************/
  // Propiedades para Image Cropper
  imageChangedEventInicial: any = '';
  imageChangedEventFinal: any = '';
  croppedImageInicial: string = '';
  croppedImageFinal: string = '';
  bolCroppedImgInicial: boolean = false;
  bolCroppedImgFinal: boolean = false;
  rawFileInicial: any;
  rawFileFinal: any;

  // Previsualización de las imágenes
  previewUrlInicial: string | null = null;
  previewUrlFinal: string | null = null;

  fileChangeEvent(event: any, tipo: 'inicial' | 'final'): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (tipo === 'inicial') {
          this.imageChangedEventInicial = event;
          this.bolCroppedImgInicial = true;
          this.rawFileInicial = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        } else {
          this.imageChangedEventFinal = event;
          this.bolCroppedImgFinal = true;
          this.rawFileFinal = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        }
      };
      reader.readAsBinaryString(file);
    }
  }

  imageCropped(event: ImageCroppedEvent, tipo: 'inicial' | 'final') {
    console.log("imageCropped()", event.base64)
    if (tipo === 'inicial') {
      this.croppedImageInicial = event.base64 || '';
      // this.previewUrlInicial = this.croppedImageInicial;
    } else {
      this.croppedImageFinal = event.base64 || '';
      // this.previewUrlFinal = this.croppedImageFinal;
    }

    let croppedImage = event.base64.replace(/^data:.+;base64,/, '');
    let name = tipo === 'inicial' ? this.rawFileInicial.name : this.rawFileFinal.name;
    let type = tipo === 'inicial' ? this.rawFileInicial.type : this.rawFileFinal.type;
    this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), name, croppedImage, type).subscribe({
      next: (fileData: any) => {
        if (tipo === 'inicial') {
          this.rawFileInicial.url = fileData.fileName;
        } else {
          this.rawFileFinal.url = fileData.fileName;
        }
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

  imageLoaded(tipo: 'inicial' | 'final') {
    console.log(`Image loaded for ${tipo}`);
  }

  cropperReady(event: any, tipo: 'inicial' | 'final') {
    console.log(`Cropper ready for ${tipo}`, event);
  }

  loadImageFailed(tipo: 'inicial' | 'final') {
    console.error(`Failed to load image for ${tipo}`);
    this.deleteImage(tipo);
  }

  deleteImage(tipo: 'inicial' | 'final') {
    if (tipo === 'inicial') {
      this.imageChangedEventInicial = '';
      this.croppedImageInicial = '';
      this.bolCroppedImgInicial = false;
      this.previewUrlInicial = null;
      this.rawFileInicial = null;
    } else {
      this.imageChangedEventFinal = '';
      this.croppedImageFinal = '';
      this.bolCroppedImgFinal = false;
      this.previewUrlFinal = null;
      this.rawFileFinal = null;
    }
  }


  // VIDEO
  videoUrl: SafeResourceUrl | null = null;
  updateVideoDetails() {
    const link = 'https://youtu.be/'+this.formEjercicio.get('linkVideo')?.value;
    if (link) {
      const videoId = this.extractVideoId(link);
      if (videoId) {
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://www.youtube.com/embed/${videoId}`
        );
      } else {
        this.videoUrl = null; // Limpia la URL si no es válida
      }
    }
  }

  private extractVideoId(url: string): string | null {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }


  get formEjercicioControl()
  {
    return this.formEjercicio.controls;
  }

  modalTagsFn(){
    console.log(this.arrTags)
    $('.ejercicio>input[type=checkbox]').each(function() {
      $(this).attr('checked', false);
    })

    let arr = this.arrTags
    $('.ejercicio>input[type=checkbox]').each(function() {
      let currentValue = this.value;  // or +this.value or other conversion
      if (arr.indexOf(currentValue) !== -1) {
        $(this).attr('checked', 'checked');
      }
    })
    $('#modal-tags').modal('show');
  }
  onCheckboxEquipmentChange(e: any) {
    console.log(e.target.checked)
    console.log(e.target.value)

    if(e.target.checked){
      this.arrTags.push(e.target.value);
    }else{
      let i: number = 0;
      this.arrTags.forEach((item: any) => {
        if (item == e.target.value) {
          this.arrTags.splice(i, 1);
          return;
        }
        i++;
      });
    }

    console.log('arr tags', this.arrTags)
  }

    openModalTagsSearch(){
      console.log(this.tiposEjercicios)
      console.log(this.arrTags)
      $("#modal-tags-search").modal("show")
    }

    onCheckboxTagsSearchChange(e: any) {
      //this.arrTagsFilter = []
      if(e.target.checked){
            this.arrTagsSearch.push(e.target.value);
        }else{
            let i: number = 0;
            this.arrTagsSearch.forEach((item: any) => {
                if (item == e.target.value) {
                    this.arrTagsSearch.splice(i, 1);
                    return;
                }
                i++;
            });
        }

        let arrQuery: any = []
        let obj: any = {};
        this.arrTagsFilter = []
        for(let j in this.arrTagsSearch){
            let match_phrase: any = {}
            obj = {}
            match_phrase['tags.keyword'] = this.arrTagsSearch[j]
            obj.match_phrase = match_phrase
            this.arrTagsFilter.push(obj)
        }

        console.log(this.arrTagsFilter)
        console.log(this.arrTagsSearch)
        console.log(this.arrTags)
    }

    agregarTagsAFiltros(){ //CHECKPOINT
    // se borran los tags de tipo, nivel y mecanica del arreglo y luego se agregan los seleccionados
      this.arrTagsSearch = this.arrTagsSearch.filter(item => !this.tiposEjercicios.includes(item));
      this.arrTagsSearch = this.arrTagsSearch.filter(item => !this.nivelesEjercicios.includes(item));
      this.arrTagsSearch = this.arrTagsSearch.filter(item => !this.mecanicasEjercicios.includes(item));

      if(this.tagTipoSeleccionado != '') this.arrTagsSearch.push(this.tagTipoSeleccionado);
      if(this.tagNivelSeleccionado != '') this.arrTagsSearch.push(this.tagNivelSeleccionado);
      if(this.tagMecanicaSeleccionado != '') this.arrTagsSearch.push(this.tagMecanicaSeleccionado);

      let arrQuery: any = []
      let obj: any = {};
      this.arrTagsFilter = []
      for(let j in this.arrTagsSearch){
        let match_phrase: any = {}
        obj = {}
        match_phrase['tags.keyword'] = this.arrTagsSearch[j]
        obj.match_phrase = match_phrase
        this.arrTagsFilter.push(obj)
        }

    }

    toggleSelection(value: string) {
      if (this.tagTipoSeleccionado === value) {
        this.tagTipoSeleccionado = ''; // Deseleccionar si se hace clic en la misma opción
      }
      if (this.tagNivelSeleccionado === value) {
        this.tagNivelSeleccionado = ''; // Deseleccionar si se hace clic en la misma opción
      }
      if (this.tagMecanicaSeleccionado === value) {
        this.tagMecanicaSeleccionado = ''; // Deseleccionar si se hace clic en la misma opción
      }
    }

    consultaEjerciciosTags(){

    this.agregarTagsAFiltros()
    
      let bool: any = {}
      let bool2: any = {}
      let should: any = []
      let should2: any = []

      should = this.arrTagsFilter

      switch (this.filtroPropietario){
        case 'todos':
          should2.push({
                "match_phrase": {
                  "documentContainerId.keyword": this.userInfo.documentContainerId
                }
              },
              {
                "match_phrase": {
                  "documentContainerId.keyword": this.env.empresaBaseId
                }
              })

          break;
        case 'empresaBase':
          should2.push({
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          })
          break;
        case 'propios':
          should2.push({
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          })
          break;
      }

      bool.should = should
      bool2.should = should2

      const query = {
        "sort": [
          {
            "esDocumentDate": {
              "order": "desc",
              "unmapped_type": "boolean"
            }
          }
        ],
        "size": 200,
        "query": {
          "bool": {
            "must": [],
            "filter": [{ "bool": bool}, { "bool": bool2}],
            "should": [],
            "must_not": []
          }
        }
      };

    this.documentService
          .searchDocument(
              environment.businessId,
              this.pattern,
              query
          )
          .subscribe({
            next: (data) => {
              console.log(data)
              this.listaEjercicios = [];
              this.listaEjerciciosFiltrada = [];
              this.listaEjercicios = data;
              this.listaEjerciciosFiltrada = data;
              this.filtrarPorNombre({target: {value: this.filtroNombreTemp}});
              $("#modal-tags-search").modal("hide")
            },
            error: (error) => {
              console.error(error);
            },
          });
    }

  // Método de filtrado
  filtrarPorNombre(event: any) {
    const valor = event.target.value.toLowerCase().trim();
    this.filtroNombreTemp = valor;
    // Si no hay valor, mostrar todos
    if (!valor) {
      // this.getEjercicios();
      this.listaEjerciciosFiltrada = this.listaEjercicios;
      return;
    }
    // Filtrar la lista actual
    this.listaEjerciciosFiltrada = this.listaEjercicios.filter(ejercicio =>
      ejercicio.nombre1.toLowerCase().includes(valor) ||
      (ejercicio.nombre2 && ejercicio.nombre2.toLowerCase().includes(valor))
    );
  }
}
